// Report years, as the server stamps them (server/server/report_year.py). A
// year is named for the year it leads into and started November 1 through
// 2026; Report Year 2027 starts 2026-10-01 (REQ-71), a one-off date: no later
// year is defined, so every date from then on is 2027. Reports are due
// December 31 of the year before.
const STARTS = { 2027: [2026, 9, 1] } // [year, month index, day]
export const LATEST_REPORT_YEAR = 2027

export function reportYearStart(year) {
  const [y, m, d] = STARTS[year] || [year - 1, 10, 1]
  return new Date(y, m, d)
}

export function currentReportYear(today = new Date()) {
  if (today >= reportYearStart(LATEST_REPORT_YEAR)) return LATEST_REPORT_YEAR
  return today.getMonth() >= 10 ? today.getFullYear() + 1 : today.getFullYear()
}

// "October 1, 2026"
export function formatReportYearStart(year) {
  return reportYearStart(year).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
}
